﻿export const whyUsCarousel = () => {
    const directions = { 
        left: 'left', 
        right: 'right' 
    };

    const blocks = [
        '.why-us-module__content-items-image-list .row', 
        '.why-us-module__content-items-title-list .row', 
        '.items'
    ];

    const move = (component, direction) => {
            blocks.forEach(selector => {
                const container = component.querySelector(`${selector}`);
                const firstChild = component.querySelector(`${selector} > div:first-child`);
                const lastChild = component.querySelector(`${selector} > div:last-child`);

                if(direction === directions.left){
                    container.appendChild(firstChild);
                } else {
                    container.insertBefore(lastChild, firstChild)
                }                
            });
    };

    const init = component => {
        const leftArrow = component.querySelector('.left-arrow');
        const rightArrow = component.querySelector('.right-arrow');

        rightArrow.addEventListener('click', () => move(component, directions.right));
        leftArrow.addEventListener('click', () => move(component, directions.left));
    };

    return {
        init: init,
        selector: '[data-component="why-us-module"]'
    };
};